import { mapState } from 'vuex';

import PAGINATION from '@sdk/helpers/misc/pagination';

const ALL = {
  per_page: PAGINATION.MAX_PER_PAGE,
};

const kinds = [
  'domains',
  'domainsWeb',
  'banks',
  'banksWeb',
  'stores',
  'sellers',
  'vehicleModels',
  'returnDomains',
  'vehicleDomains',
  'vehicleFilters',
];

export default {
  computed: {
    ...mapState([
      ...kinds,
    ]),
  },
  methods: {
    preloadExpired(kind, cached, payload) {
      const {
        datetime,
        filters,
        items,
      } = this[kind].list;

      if (!cached || !datetime) {
        return true;
      }

      if (((new Date()) - datetime) > 60 * 60 * 1000) {
        return true;
      }

      if (JSON.stringify(filters) !== JSON.stringify(payload)) {
        return true;
      }

      return !Object.keys(items).length;
    },

    reloadKind(kind) {
      const key = kind.charAt(0).toUpperCase() + kind.substr(1);
      const reloader = `reload${key}`;

      if (this[reloader] && this[kind] && this[kind].list && this[kind].list.filters) {
        this[reloader](this[kind].list.filters);
      }
    },

    preloadKind(kind, cached, payload) {
      if (this.preloadExpired(kind, cached, payload)) {
        this.$store.dispatch(`${kind}/filter`, {
          ...payload,
        });

        return this.$store.dispatch(`${kind}/list`, {
          ...ALL,
          ...payload,
        });
      }

      return Promise.resolve();
    },

    ...kinds.reduce((state, item) => {
      const key = item.charAt(0).toUpperCase() + item.substr(1);

      state[`preload${key}`] = function preloader(cached = true, payload = {}) {
        return this.preloadKind(item, cached, payload);
      };

      return state;
    }, {}),
  },
};
